import React from 'react';
import logo from '../images/logo.webp';

import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
	const location = useLocation();

	return (
		<>
			<div className='flex px-4 pt-4 h-16 w-full items-center sticky bg-white z-10'>
				<div className='flex justify-start items-center'>
					{/* Logo Section */}
					<div className='pl-5 max-[440px]:block'>
						<Link to='/'>
							<img
								src={logo}
								alt='Logo'
								className='w-16 object-cover aspect-auto max-[440px]:w-10'
							/>
						</Link>
					</div>
				</div>
				{/* Centered Navbar Links */}
				<div className='flex flex-grow justify-center'>
					<ul className='flex flex-row gap-10 font-semibold'>
						{[{ name: 'Home', link: '/' }].map((item) => (
							<li
								key={item.name}
								className={`cursor-pointer ${
									location.pathname === item.link ? 'text-red-500' : ''
								}`}>
								<Link to={item.link}>{item.name}</Link>
							</li>
						))}
					</ul>
				</div>
			</div>
		</>
	);
};

export default Navbar;
